import { render, staticRenderFns } from "./index.vue?vue&type=template&id=44dd25cf"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=44dd25cf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports